<template>
  <div class="notfound">
    <div class="notfound-content">
      <p>404 - Page not found</p>
      <div><img src="/404.jpg" /></div>
      <div>
        <b-button variant="coal-yellow" class="big" @click="$router.push({ name: 'home' });">
          Back to home
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';

  .notfound {
    height: calc(100vh - 220px);
    width: 100%;
    text-align: center;
    display: table;

    .notfound-content {
      display: table-cell;
      text-align: center;
      vertical-align: middle;
    }
  }

  p {
    margin-bottom: 60px;
    color: $white;
    font-size: $font-size-out-of-nowhere;
    text-align: center;
  }

  img {
    max-width: 100%;
  }

  button {
    margin-top: 60px;
  }
</style>
